import { countryList } from "../constants/countries";

export const getCountryName = (value: string): string => {
  const country = countryList.find((c: any) => c.value === value);
  return country ? country.label : "";
};
